export default "__VITE_ASSET__Dp1eCoJ6__"